<template>
  <div class="schedule-page" >
    <div class="sched-summary">
      <div class="sched-summary__column">
        <info-block
          :toggable="false"
          class="info-block--calendar info-block--border"
        >
          <div class="info-block__header">
            <i class="info-block__marker" style="background: #F05959;" />
            <div class="info-block__header-wrapper">
              <div class="info-block__title">
                <span>{{ $t('labels.pick_date')}}</span>
                <el-button
                  type="primary"
                  plain
                  @click="toDateNow"
                >
                  {{ $t('labels.today') }}
                </el-button>
              </div>
            </div>
          </div>
          <Calendar
            :value="calendarValue"
            :month-diff="monthDiff"
            :available="availableDays"
            @input="onInputCalendar"
            @monthDiffDown="onMonthDiffDown"
            @monthDiffUp="onMonthDiffUp"
          />
        </info-block>
        <info-block
          v-if="userGroups"
          :title="$t('labels.calendars')"
          marker-color="#F3AD36"
          :toggable="false"
          class="info-block--groups"
        >
          <el-checkbox-group v-model="selectedGroups">
            <el-checkbox
              v-for="group in userGroups"
              ref="groups"
              :key="group.ID"
              :class="getGroupClass(group)"
              checked
              :label="group[SCHEDULE_GROUP_NAME]"
            >
              {{ group[SCHEDULE_GROUP_NAME] }}
            </el-checkbox>
          </el-checkbox-group>
        </info-block>
        <!-- <info-block
          :toggable="false"
          class="info-block--subscription info-block--border"
        >
          <div class="info-block__header">
            <div class="info-block__header-wrapper">
              <div class="info-block__title">
                <span>Подписка на календарь</span>
                <el-popover width="auto" trigger="click" :visible-arrow="false" placement="top" content="Тот кто совершает действие.">
                  <div class="info-block-hint" slot="reference" />
                </el-popover>
              </div>
            </div>
          </div>
          <el-button
            type="primary"
            plain
          >
            Подписаться на календарь
          </el-button>
        </info-block> -->
      </div>
      <div class="sched-summary__column">
        <ScheduleBlock
          :id="id"
          :schedule="groups1"
          :is-list="isList"
          :max-groups="maxGroups"
          @makeList="onMakeList"
          @addList="onAddList"
        />
      </div>
    </div>
  </div>
</template>
<script>
  import moment from 'moment'
  import store from '@/store'
  import ScheduleBlock from './scheduleBlock.vue';
  import Calendar from '@/components/Calendar/Calendar.vue';
  import {DateTime} from 'luxon'
  import {SCHEDULE_GROUP_NAME} from '@/constants'
  import {momentLang as lang} from '@/lang/index'

  const todayMomentFormat = moment().locale(lang).format('YYYY-MM-DDT00:00:00');
  const todayMomentFormatForBack = moment().locale('en').format('YYYY-MM-DDT00:00:00');

  export default {
    props: {
      id: String
    },
    data () {
      return {
        loaded: false,
        isList: true,
        listStep: 3,
        maxGroups: 3,
        calendarStartDate: todayMomentFormat,
        calendarStartDateForBack: todayMomentFormatForBack,
        calendarEndDate: '2052-08-30T00:00:00',
        calendarEndDateForBack: '2052-08-30T00:00:00',
        sched: null,
        calendarSched: [],
        calendarValue: todayMomentFormat,
        monthDiff: 0,
        selectedGroups: [],
        nowDay: moment().locale('en').format('DD.MM.YYYY, ') + moment().locale(lang).format('dddd'),
        SCHEDULE_GROUP_NAME
      }
    },
    components: {
      ScheduleBlock,
      Calendar
    },
    async mounted () {
      store.commit('appInterface/setLoaderBar', true);
      await this.loadSchedule();
      await this.loadCalendarSchedule();
    },
    computed: {
      student () {
        return this.$store.state.students.students[this.id]
      },
      availableDays () {
        let map = {};
        for (const day in this.calendarSched) {
          let date = this.getDateForCalendar(this.calendarSched[day])
          if (!map[date]) {
            map[date] = []
          }
          map[date].push(this.calendarSched[day])
        }
        return map;
      },
      userGroups () {
        if (this.student && this.student.data.stud.cards) {
          return this.student.data.stud.cards;
        }
        return [];
      },
      selectedGroupsReal: {
        get () {
          return this.userGroups.map(item => item[SCHEDULE_GROUP_NAME]);
        },
        set (val) {
          return val;
        }
      },
      groups1 () {
        let map = {
          [this.nowDay]: []
        };
        for (const day in this.sched) {
          let date = this.getDate(this.sched[day])
          if (!map[date]) {
            map[date] = []
          }
          map[date].push(this.sched[day])
        }
        return map;
      }
    },
    methods: {
      getGroupClass (group) {
        const groupKey = SCHEDULE_GROUP_NAME;
        const groups = this.userGroups;
        for (let gr in groups) {
          if (groups[gr][groupKey] === group[groupKey]) {
            return `isColor${+gr + 1}`;
          }
        }
      },
      onMonthDiffDown () {
        this.onMonthChange(-1);
      },
      onMonthDiffUp () {
        this.onMonthChange(1);
      },
      onMonthChange (diff) {
        if (diff === 0) {
          this.monthDiff = 0;
        } else {
          this.monthDiff = this.monthDiff + diff;
        }
        this.loadCalendarSchedule();
      },
      onInputCalendar (val) {
        const date = moment(val).locale(lang);
        const dateFormat = date.format('YYYY-MM-DDT00:00:00')
        this.calendarStartDate = dateFormat;
        this.calendarStartDateForBack = moment(val).locale('en').format('YYYY-MM-DDT00:00:00');
        this.calendarValue = dateFormat;
        this.nowDay = moment(val).locale('en').format('DD.MM.YYYY, ') + date.format('dddd');
        if (!this.isList) {
          this.calendarEndDate = date.format('YYYY-MM-DDT23:59:59');
          this.calendarEndDateForBack = moment(val).locale('en').format('YYYY-MM-DDT23:59:59');
        }
      },
      toDateNow () {
        this.calendarStartDate = todayMomentFormat;
        this.calendarStartDateForBack = todayMomentFormatForBack;
        this.calendarValue = todayMomentFormat;
        this.nowDay = moment().locale('en').format('DD.MM.YYYY, ') + moment().locale(lang).format('dddd');
        if (!this.isList) {
          this.calendarEndDate = moment().locale(lang).format('YYYY-MM-DDT23:59:59');
          this.calendarEndDateForBack = moment().locale('en').format('YYYY-MM-DDT23:59:59');
        }
        this.onMonthChange(0);
      },
      onAddList () {
        this.maxGroups += this.listStep;
      },
      onMakeList (isList) {
        if (isList) {
          this.calendarEndDate = '2052-08-30T00:00:00';
          this.calendarEndDateForBack = '2052-08-30T00:00:00';
        } else {
          this.calendarEndDate = moment(this.calendarStartDate).locale(lang).format('YYYY-MM-DDT23:59:59');
          this.calendarEndDateForBack = moment(this.calendarStartDateForBack).locale('en').format('YYYY-MM-DDT23:59:59');
        }
        this.isList = isList;
        this.loadSchedule();
      },
      async loadSchedule () {
        store.commit('appInterface/setLoaderBar', true);
        const groupIds = this.loaded ? this.selectedGroups : this.selectedGroupsReal;

        if (groupIds && !groupIds.length) {
          this.sched = [];
          store.commit('appInterface/setLoaderBar', false);
          return;
        }

        const data = {
          lsn_id: 'calendarGet',
          group_ids: groupIds,
          beg_ts: this.calendarStartDateForBack,
          end_ts: this.calendarEndDateForBack
        }
        try {
          await store.dispatch('sched/get', data);
          this.sched = store.state.sched.sched;
          this.loaded = true;
        } catch (error) {
          this.sched = [];
          // @ts-ignore
          this.$message.error(this.$t('labels.schedule_download_error'))
        } finally {
          store.commit('appInterface/setLoaderBar', false);
        }
      },
      async loadCalendarSchedule () {
        store.commit('appInterface/setLoaderBar', true);

        const groupIds = this.loaded ? this.selectedGroups : this.selectedGroupsReal;
        const calendarBegTs = this.getCalendarDateWithMonthDiff(-2);
        const calendarEndTs = this.getCalendarDateWithMonthDiff(2);

        if (groupIds && !groupIds.length) {
          this.calendarSched = [];
          store.commit('appInterface/setLoaderBar', false);
          return;
        }

        const data = {
          lsn_id: 'calendarGet',
          group_ids: groupIds,
          beg_ts: calendarBegTs,
          end_ts: calendarEndTs
        }

        try {
          await store.dispatch('sched/calendarGet', data);
          this.calendarSched = store.state.sched.calendar_sched;
        } catch (error) {
          this.calendarSched = [];
        } finally {
          store.commit('appInterface/setLoaderBar', false);
        }
      },
      getCalendarDateWithMonthDiff (diff) {
        return moment(this.calendarStartDateForBack).add(this.monthDiff + diff, 'months').format('YYYY-MM-01T00:00:00');
      },
      getDate ({beg_ts}) {
        const date = new Date(beg_ts);
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        const weekDay = moment(date).locale(lang).format('dddd');

        return `${day < 10 ? `0${day}` : day}.${month < 10 ? `0${month}` : month}.${year}, ${weekDay}`;
      },
      getDateForCalendar ({beg_ts}) {
        const date = new Date(beg_ts);
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();

        return `${year}.${month}.${day}`;
      },
      getDay (data) {
        let ts = this.getTs(data)
        return DateTime.fromMillis(ts).setLocale('ru').toFormat('dd');
      },
      getTs (data) {
        return +data.beg_ts || 0
      }
    },
    watch: {
      async calendarStartDate () {
        await this.loadSchedule();
      },
      selectedGroups () {
        if (this.loaded) {
          this.loadSchedule();
          this.loadCalendarSchedule();
        }
      }
    }
  }
</script>
<style lang="scss">
@import 'src/assets/sass/core';

@mixin InfoColor($color) {
  &.el-checkbox.is-checked {
    .el-checkbox__inner {
      background-color: $color;
      border-color: $color;
    }
  }
  &.schedule-event:before {
    border-color: $color;
  }
}

.sched-summary {
  display: grid;
  grid-template-columns: 250px 1fr;
  grid-column-gap: 30px;

  @include respond-to(phone) {
    grid-template-columns: 1fr;
  }

  &__column {
    display: grid;
    grid-auto-rows: max-content;
    min-width: 0;
  }
  &__column:first-child > * {
    max-width: 250px;
    @include respond-to(phone) {
      max-width: 100%;
    }
  }
  &__column:last-child {
    .info-block__header, .info-block__content {
      padding-left: 30px;
      @include respond-to(phone) {
        padding-left: 19px;
      }
    }
  }
  &__item {
    overflow-x: auto;
  }

  .info-block__content, .info-block__header {
    padding-left: 20px;
    padding-right: 20px;
  }

  .el-checkbox {
    margin-left: 0 !important;
    margin-bottom: 0;
    white-space: normal;
    display: flex;
    align-items: center;
    font-weight: normal;

    & + .el-checkbox {
      margin-top: 9px;
    }
    &, &.is-checked {
      .el-checkbox__label {
        color: #333;
      }
    }
    &__inner:after {
      border-width: 2px;
      left: 3.5px;
      top: 0;
    }
  }

  .isColor1{
    @include InfoColor(#4972DC);
  }
  .isColor2{
    @include InfoColor(#A377FF);
  }
  .isColor3{
    @include InfoColor(#FFC93D);
  }
  .isColor4{
    @include InfoColor(#E840E1);
  }
  .isColor5{
    @include InfoColor(#B240E8);
  }
  .isColor6{
    @include InfoColor(#FF8F3D);
  }
  .isColor7{
    @include InfoColor(#FF603D);
  }
  .isColor8{
    @include InfoColor(#97E631);
  }
  .isColor9{
    @include InfoColor(#38D020);
  }
  .isColor10{
    @include InfoColor(#20D0A6);
  }
  .isColor11{
    @include InfoColor(#49DCDC);
  }
  .isColor12{
    @include InfoColor(#49B9DC);
  }
}

.info-block {
  &--calendar {
    .info-block__content {
      padding: 0;
    }
    .info-block__title {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .el-button {
      padding: 4px 5px;
      width: 70px;
      text-align: center;
    }
  }
  &--groups {
    .info-block__content {
      padding-top: 5px;
    }
  }
  &--subscription {
    .info-block__header {
      margin: 0 -20px 15px;
      min-height: 52px;
    }
    .info-block__title {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .info-block-hint {
      cursor: pointer;
      min-width: 18px;
      min-height: 18px;
      background: url('/static/img/question-mark.svg') 0 0 no-repeat;
    }
    .info-block__content {
      padding-top: 0;
    }
    .el-button {
      width: 100%;
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  &--border &__header {
    border-bottom: 1px solid #DCDFE5;
  }
  .el-button {
    font-weight: normal;
    &.is-plain {
      background: none;
      color: #2f80ed;
      border-color: #2f80ed;
    }
  }
}
</style>